/* unplugin-vue-components disabled */
import {DataTable, Column} from 'components/data-table'
import AddModal from './add-modal.vue'
import EditModal from './edit-tenant-modal.vue'
import $tenants from 'stores/tenants'
import $global from 'stores/global'
import $profile from 'stores/profile'

export default {
  components: {
    DataTable,
    AddModal,
    EditModal,
    Column
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    view_items() {
      return $tenants.view_items
    },
    view_total() {
      return $tenants.view_total
    },
    total() {
      return $tenants.total
    },
    refreshing() {
      return $tenants.loading
    },
  },
  async mounted() {
    if (!$profile.is_admin) {
      $global.goToChats()
      return
    }
    this.loading = true
    await $tenants.load()
    this.loading = false
  },
  methods: {
    onAddTenant() {
      this.$refs.addModal.open()
    },
    onEditTenant(id) {
      const tenant = $tenants.getTenant(id)
      this.$refs.editModal.open(tenant)
    },
    onGoToTenant(id) {
      $global.goToTenant(id)
    },
    onRowDblclick({index}) {
      this.onGoToTenant(this.view_items[index].id)
    },
    async onNewTenant(fields) {
      try {
        await $tenants.newTenant(fields)
        await $tenants.load()
      }
      catch(err) {
        $utils.toasts.error(`Failed to add tenant: ${err}`)
      }
    },
    async onUpdateTenant(data) {
      const tenant = $tenants.getTenant(data.id)
      const old_name = tenant.name
      const old_domain = tenant.email_domain
      const old_shc_id = tenant.shared_company_id

      try {
        tenant.name = data.name
        tenant.email_domain = data.email_domain
        tenant.shared_company_id = data.shared_company_id
        await tenant.save()
      }
      catch(err) {
        $utils.toasts.error(`Failed to update tenant: ${err}`)
        tenant.name = old_name
        tenant.email_domain = old_domain
        tenant.shared_company_id = old_shc_id
      }

      // TODO: updating tenant properties somewhy doesn't update the table
      await $tenants.load()
    },

  }
}
